import authenticationControl from './authenticationControl-module.js';

$.backstretch('../img/1.jpg');

authenticationControl.initForgotPasswordPage();

$('#sendForgotPasswordForm').on('click', function (e) {
  authenticationControl.sendSecretKey();
});
